import { TFunction } from "i18next";

export const deliveryTypeList = (t: TFunction<"catalog", undefined>) => [
	{
		label: t("digital"),
		id: "digital",
	},
	{
		label: t("physical"),
		id: "physical",
	},
	{
		label: t("hybrid"),
		id: "hybrid",
	},
];

export const currencyCodes = [
	{ label: "NOK", id: 1, value: "KR" },
	{ label: "Eur", id: 2, value: "€" },
	{ label: "Sek", id: 3, value: "SEK" },
];

export const languages = [
	{ id: 2, label: "Norwegian", value: "no" },
	{ id: 4, label: "Swedish", value: "sv" },
	{ id: 3, label: "Danish", value: "da" },
	{ id: 5, label: "Finnish", value: "fi" },
	{ id: 6, label: "Albanian", value: "sq" },
	{ id: 1, label: "English", value: "en" },
];

export const countries = [
	{ id: 1, label: "Norway" },
	{ id: 2, label: "Sweden" },
	{ id: 3, label: "Denmark" },
	{ id: 4, label: "Finland" },
	{ id: 5, label: "Kosovo" },
	{ id: 6, label: "Usa" },
];

export const phonePrefixes = ["+47", "+208", "+352", "+246", "+578"];

export const placeholderAvatar =
	"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='32' fill='%23F2F4F7'/%3E%3Ccircle cx='32' cy='26' r='10' fill='%23D0D5DD'/%3E%3Cpath d='M16 52c3-9 29-9 32 0' fill='%23D0D5DD'/%3E%3C/svg%3E";
